import { Box, Typography } from '@mui/material';
import DiamondIcon from '@mui/icons-material/Diamond';
import { components } from '@common/types';

interface TeamAssignmentListItemProps {
  team: components['schemas']['TeamAssignment'];
}

export const TeamAssignmentListItem = ({
  team,
}: TeamAssignmentListItemProps) => (
  <Box
    sx={{
      display: 'flex',
      width: '100%',
      gap: '1rem',
      alignItems: 'center',
    }}
  >
    <DiamondIcon sx={{ color: team.color, height: '28px', width: '28px' }} />
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant='body1' sx={{ fontWeight: 'normal' }}>
        {team.name}
      </Typography>
      <Typography
        variant='body2'
        sx={{ color: theme => theme.palette.semiBlack.main }}
      >
        Team
      </Typography>
    </Box>
  </Box>
);
